import * as APITypes from "~/API";
import { getPropertyList } from "~/services/server";
import type { EntityListData, EntityListOptions } from "~/types";

export const formatPropertyOptions = (
  propertyList: APITypes.Property[]
): EntityListOptions[] => {
  return propertyList.map((property) => ({
    value: property.id,
    text: property.name.toString(),
  }));
};

export const getPropertyEntityList = async (
  ownerID: string,
  ownerType: APITypes.OwnerType
): Promise<EntityListData> => {
  const propertyList = await getPropertyList({ ownerID, ownerType });

  return {
    propertyList: propertyList.data,
    buildingList: [],
    unitList: [],
    serviceRequestList: [],
    amenityList: [],
    propertyMap: {},
    buildingMap: {},
    unitMap: {},
  };
};
